import styled from "styled-components";

export const MissingZoneWrapper = styled.div`
  width: 100%;
  margin: 2em 0;
  display: flex;
  gap: 1em;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  img {
    width: 90%;
    max-width: 400px;
    margin-bottom: 2em;

    @media (max-width: 768px) {
      width: 75%;
    }
  }

  h2 {
    font-weight: 600;
  }

  p {
    color: var(--dark-light);
    margin-bottom: 1em;

    span {
      /* color: var(--dark-light); */
      font-weight: 700;
    }
  }
`;
